import http from "../../httpService";
import { apiUrl } from "../../../../config.js";

const apiEndpoint = apiUrl + "/setup/company-profile/";

export function getCompanyProfileGlobalData() {
  return http.get(apiEndpoint + "company-profile-global-data");
}

export function getCompanyProfiles() {
  return http.get(apiEndpoint);
}

export function getCompanyProfileInitialSetup() {
  return http.get(apiEndpoint + "company-profile-initial-setup");
}

export function updateCompanyHostURL(hostURL) {
  return http.put(apiEndpoint + "update-company-host-url", hostURL);
}

export function activateCompanyProfileLicense(licenseKey) {
  return http.put(
    apiEndpoint + "activate-company-profile-license-key",
    licenseKey
  );
}

export function createCompanyProfile(companyProfile) {
  return http.put(apiEndpoint + "create-company-profile", companyProfile);
}

export function uploadCompanyProfileLogo(files) {
  return http.post(apiEndpoint + "upload-company-profile-logo", files);
}

export function uploadCompanyProfileTheme(files) {
  return http.post(apiEndpoint + "upload-company-profile-theme", files);
}

export function updateCompanyProfileAdminPassword(newAdminPassword) {
  return http.put(
    apiEndpoint + "update-company-profile-admin-password",
    newAdminPassword
  );
}

export function getCompanyProfile() {
  return http.get(apiEndpoint + "company-profile-detail");
}

export function getCompanyThemes() {
  return http.get(apiEndpoint + "company-themes");
}

export function getCompanyProfileTheme() {
  return http.get(apiEndpoint + "company-profile-theme");
}

export function saveCompanyProfileLogo(files) {
  return http.post(apiEndpoint + "company-profile", files);
}

export function saveCompanyProfile(companyProfile) {
  if (companyProfile.ID === 0) {
    return http.post(apiEndpoint, companyProfile);
  } else {
    return http.put(apiEndpoint, companyProfile);
  }
}

export function getCompanyPreferences() {
  return http.get(apiEndpoint + "company-preferences");
}

export function saveCompanyPreferences(companyPreferences) {
  if (companyPreferences.ID === 0) {
    return http.post(apiEndpoint + "company-preferences", companyPreferences);
  } else {
    return http.put(apiEndpoint + "company-preferences", companyPreferences);
  }
}

export function getCompanyProfileMaster() {
  return http.get(apiEndpoint + "company-profile-master");
}

export function getCompanyLicenseDashboard() {
  return http.get(apiEndpoint + "company-license-dashboard");
}
